var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "re_upload_prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#re_upload_prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.603v8.58q0 1.492 1.055 2.547 1.056 1.056 2.548 1.056h5.368a.171.171 0 00.133-.281q-.464-.562-.728-1.24a.172.172 0 00-.16-.11H3.603q-.817 0-1.395-.577Q1.63 13 1.63 12.182v-.628q.034-.037.063-.078 1.364-1.91 2.554-1.91 1.138 0 2.886 3.023v.001q.236.407.706.407.037 0 .074-.003a.172.172 0 00.156-.179q-.005-.102-.005-.204 0-.634.174-1.244a.172.172 0 00-.02-.137q-.677-1.091-1.338-1.82 1.76-2.418 3.35-2.418.797 0 1.797 1.042a.172.172 0 00.14.052q.222-.022.444-.022.664 0 1.3.19a.172.172 0 00.185-.268Q12.1 5.362 10.23 5.362q-2.38 0-4.595 2.99-.7-.416-1.388-.416-1.348 0-2.617 1.144V3.603q0-.817.578-1.395.578-.578 1.395-.578h8.58q.817 0 1.395.578.578.578.578 1.395v4.613c0 .07.043.134.109.16q.678.264 1.24.728a.171.171 0 00.28-.133V3.603q0-1.492-1.055-2.548Q13.675 0 12.182 0H3.603Q2.111 0 1.055 1.055 0 2.111 0 3.603zM3.603.172zm4.204 12.653zM3.733 6.047q.302.302.728.302.427 0 .728-.302.302-.302.302-.728t-.302-.728q-.301-.301-.728-.301-.426 0-.728.301-.301.302-.301.728t.301.728zm9.693 5.696V9.988q0-.337-.238-.576-.24-.239-.577-.239-.337 0-.576.239-.239.239-.239.576v1.755h-1.758q-.338 0-.577.238-.238.24-.238.577 0 .337.238.576.239.239.576.239h1.76v1.763q0 .337.238.576.239.239.576.239.338 0 .577-.24.238-.238.238-.575v-1.763h1.759q.338 0 .576-.24.239-.238.239-.575 0-.338-.239-.577-.238-.238-.576-.238h-1.759z",
    fillRule: "evenodd",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReUpload);
export default __webpack_public_path__ + "static/media/re_upload.7d438dd5e2e703363096d3e727aef3c3.svg";
export { ForwardRef as ReactComponent };